import axios from 'axios';

const create = (data) => axios.post('/clientes', data);
const get = (id) => axios.get(`/clientes/${id}`);
const list = (params) => axios.get('/clientes', { params });
const update = (id, cliente) => axios.put(`/clientes/${id}`, cliente);
const remove = (id) => axios.delete(`/clientes/${id}`, {});
const save = (cliente) => {
  if (cliente.id) {
    return update(cliente.id, cliente);
  }
  return create(cliente);
};

export default {
  create,
  get,
  list,
  update,
  save,
  remove,
};
